import PropTypes from "prop-types";
import clsx from "clsx";

const Button = ({ children, onClick, type, className, disabled, loading }) => (
  <button
    type={type}
    onClick={onClick}
    className={clsx(
      "px-2 py-2 rounded-md text-white border-2 border-solid mb-2 h-8 cursor-pointer transition-colors duration-300",
      "border-black hover:enabled:bg-green-500 active:enabled:border-inset",
      {
        "bg-green-700": !className?.includes('secondary') && !disabled,
        "bg-gray-700": className?.includes('secondary') && !disabled,
        "bg-gray-500 cursor-default hover:bg-gray-500 active:border-solid": disabled,
      },
      className
    )}
    disabled={disabled}
    style={{
      borderStyle: 'groove'
    }}
    onMouseDown={(e) => {
      if (!disabled) {
        e.currentTarget.style.borderStyle = 'inset';
      }
    }}
    onMouseUp={(e) => {
      if (!disabled) {
        e.currentTarget.style.borderStyle = 'groove';
      }
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.borderStyle = 'groove';
    }}
  >
    {loading ? "Carregando..." : children}
  </button>
);

Button.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool
};

Button.defaultProps = {
  type: "button",
  disabled: false,
  loading: false,
  onClick: () => { },
};

export default Button;